module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"clearAll":"Clear all","go":"Go","lendersList":{"collapse":"Show fewer lenders","expand":"Show {n} more lender | Show {n} more lenders"},"list":{"collapse":"Show fewer providers","expand":"Show {n} more provider | Show {n} more providers"},"reset":"reset","selectAll":"Select all","title":{"institutions":"Institutions","providers":"Providers"}}}')
  delete Component.options._Ctor
}
